import readAndDownloadFile from '@/utils/downloadFile';
import apiAxios from '../../apiAdminAxios';

const downloadTripDataCsv = async ({ employerId, startDate, endDate, workTripsOnly = false }) => {
  const params = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
  });
  if (workTripsOnly) params.set('work_trips_only', '1');

  const { data } = await apiAxios.get(
    `/admin/employers/${employerId}/trip-data-csv?${params.toString()}`,
    { responseType: 'blob' },
  );

  readAndDownloadFile(data);
  return data;
};

const downloadPointsPolicyCsv = async ({ employerId, startDate, endDate }) => {
  const params = new URLSearchParams({
    start_date: startDate,
    end_date: endDate,
  });

  const { data } = await apiAxios.get(
    `/admin/employers/${employerId}/points-policy-csv?${params.toString()}`,
    { responseType: 'blob' },
  );

  readAndDownloadFile(data);
  return data;
};

export default {
  downloadTripDataCsv,
  downloadPointsPolicyCsv,
};
